import styled from 'styled-components';

import { Button } from '+/components/Button';
import { textH3 } from '+/styles/reusable/textStyles';

export const H3 = styled.h3`
  ${textH3};

  margin-bottom: 1rem;

  font-family: var(--font-tertiary);
  font-size: 1.6875rem;
  font-style: italic;
  font-weight: 400;

  color: var(--color-neutral-800);
  text-transform: none;
`;

export const DoneButton = styled(Button)`
  font-size: 1.125rem;
`;

export const ButtonWrapper = styled.div`
  margin-top: 1.5rem;
`;
